import React, { useState } from "react";
import { Card, Button, ButtonGroup, Modal, Carousel } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoIosAppstore } from "react-icons/io";
import { Link } from "react-router-dom";
import screenshot1 from "../../Assets/Projects/hootshot/01-hero-macos-2880x1800.png";
import screenshot2 from "../../Assets/Projects/hootshot/02-capture-macos-2880x1800.png";
import screenshot3 from "../../Assets/Projects/hootshot/03-annotate-macos-2880x1800.png";
import screenshot4 from "../../Assets/Projects/hootshot/04-resize-export-macos-2880x1800.png";
import screenshot5 from "../../Assets/Projects/hootshot/05-closing-macos-2880x1800.png";

const translations = {
  tr: {
    title: "HootShot",
    description: "macOS menü çubuğunda sessizce çalışan, klavyeden ayrılmadan ekran görüntüsü almanı sağlayan güçlü bir araç. Alan, pencere veya tüm ekranı yakala; ok, dikdörtgen, bulanıklaştırma ve metin ile işaretle; OCR ile yazıyı çıkar; renk seç; istediğin formatta dışa aktar.",
    details: "Detaylar",
    privacy: "Gizlilik Politikası",
    terms: "Kullanım Şartları",
    modalTitle: "HootShot - Detaylı Bilgi",
    features: [
      "📸 Yakalama: Alan, pencere veya tüm ekran",
      "✏️ İşaretleme: Ok, dikdörtgen, bulanıklaştırma, metin",
      "🔤 OCR: Görüntüden metin çıkar",
      "🎨 Renk Seçici: Ekrandan tam renk al",
      "📋 Panodan Yapıştır: Görüntüleri anında düzenle",
      "📐 Yeniden Boyutlandır: %25, %50, %75 veya hazır boyutlar",
      "💾 Çoklu Format: PNG, JPEG, HEIC, TIFF",
      "🌍 Çoklu Dil: English, Deutsch, Español, Türkçe",
      "🍎 macOS için optimize edildi"
    ]
  },
  en: {
    title: "HootShot",
    description: "A powerful screenshot tool that lives quietly in your macOS menu bar — snap, edit, and ship without leaving the keyboard. Capture an area, a window, or your whole screen; mark up with arrows, rectangles, blur, and text; extract text with OCR; pick colors; and export in the format you need.",
    details: "Details",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    modalTitle: "HootShot - Detailed Information",
    features: [
      "📸 Capture: Area, window, or full screen",
      "✏️ Annotate: Arrow, rectangle, blur, text",
      "🔤 OCR: Extract text from any image",
      "🎨 Color Picker: Grab exact colors from screen",
      "📋 Paste from Clipboard: Edit images instantly",
      "📐 Resize: 25%, 50%, 75% or preset sizes",
      "💾 Multi-format Export: PNG, JPEG, HEIC, TIFF",
      "🌍 Multi-language: English, Deutsch, Español, Türkçe",
      "🍎 Built for macOS"
    ]
  }
};

const screenshots = [screenshot1, screenshot2, screenshot3, screenshot4, screenshot5];

function HootshotCard({ imgPath }) {
  const [language, setLanguage] = useState("tr");
  const [showModal, setShowModal] = useState(false);
  const content = translations[language];

  return (
    <>
      <Card className="project-card-view">
        <Card.Img variant="top" src={imgPath} alt="card-img" />
        <Card.Body>
          <div style={{ marginBottom: "15px" }}>
            <ButtonGroup size="sm">
              <Button
                variant={language === "tr" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("tr")}
              >
                TR
              </Button>
              <Button
                variant={language === "en" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("en")}
              >
                EN
              </Button>
            </ButtonGroup>
          </div>
          <Card.Title>{content.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {content.description}
          </Card.Text>
          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
          >
            <AiOutlineInfoCircle /> &nbsp;
            {content.details}
          </Button>
          <Button
            variant="primary"
            href="https://apps.apple.com/app/hootshot/id_PLACEHOLDER"
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <IoIosAppstore /> &nbsp;
            Mac App Store
          </Button>
          <div style={{ marginTop: "10px" }}>
            <Button
              variant="outline-primary"
              as={Link}
              to="/privacy-policy/hootshot"
              size="sm"
              style={{ marginRight: "5px" }}
            >
              {content.privacy}
            </Button>
            <Button
              variant="outline-primary"
              as={Link}
              to="/terms-of-service"
              size="sm"
            >
              {content.terms}
            </Button>
            <Button
              variant="outline-primary"
              as={Link}
              to="/support/hootshot"
              size="sm"
              style={{ marginLeft: "5px" }}
            >
              {language === "tr" ? "Destek" : "Support"}
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#1a1a2e", color: "white" }}>
          <Modal.Title>{content.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#16213e", color: "white" }}>
          <Carousel>
            {screenshots.map((screenshot, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={screenshot}
                  alt={`Screenshot ${index + 1}`}
                  style={{ maxHeight: "500px", objectFit: "contain" }}
                />
              </Carousel.Item>
            ))}
          </Carousel>

          <div style={{ marginTop: "20px" }}>
            <h5 style={{ color: "#c770f0", marginBottom: "15px" }}>
              ✨ {content.modalTitle.split(" - ")[1]}
            </h5>
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {content.features.map((feature, index) => (
                <li key={index} style={{ marginBottom: "10px", fontSize: "16px" }}>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#1a1a2e", borderTop: "1px solid #c770f0" }}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default HootshotCard;
